import { render, staticRenderFns } from "./OrdersHeader.vue?vue&type=template&id=74c88f25&scoped=true"
import script from "./OrdersHeader.vue?vue&type=script&lang=ts"
export * from "./OrdersHeader.vue?vue&type=script&lang=ts"
import style0 from "./OrdersHeader.vue?vue&type=style&index=0&id=74c88f25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c88f25",
  null
  
)

export default component.exports